// extracted by mini-css-extract-plugin
export default {"clientsButton":"ClientsPageClientsList_clientsButton__cd+h8","logo":"ClientsPageClientsList_logo__hMlKi"};